
import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const [isAnimating, setIsAnimating] = useState(false);
  const [displayChildren, setDisplayChildren] = useState(children);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      setIsAnimating(true);
      
      const timer = setTimeout(() => {
        setDisplayChildren(children);
        setIsAnimating(false);
        window.scrollTo(0, 0);
      }, 300);

      prevPathRef.current = location.pathname;
      return () => clearTimeout(timer);
    } else {
      setDisplayChildren(children);
    }
  }, [location.pathname, children]);

  return (
    <>
      {/* Page transition overlay */}
      <div
        className={`fixed inset-0 z-[100] pointer-events-none transition-all duration-300 ease-out ${
          isAnimating ? 'opacity-100' : 'opacity-0'
        }`}
        aria-hidden="true"
      >
        <div
          className={`absolute inset-0 bg-gradient-to-br from-[#8E7AB5]/20 via-white to-[#8E7AB5]/10 transition-transform duration-300 ease-out ${
            isAnimating ? 'translate-y-0' : '-translate-y-full'
          }`}
        />
      </div>

      {/* Content wrapper with fade animation */}
      <div
        className={`transition-all duration-300 ease-out ${
          isAnimating ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
        }`}
      >
        {displayChildren}
      </div>
    </>
  );
}
